import { createSelector } from 'redux-orm';
import sum from 'lodash/sum';

import orm from '%paysera_seat_selection/js/seatSelection/redux/model';

import dbSelector from './dbSelector';

const SEATS_NUMBER_REQUIRED_FOR_OPTIMIZATION = 500;

const selectHallNeedToOptimize = createSelector(
    orm,
    dbSelector,
    (session) => {
        const hall = session.Hall.all().first();

        if (!hall || hall.optimized) {
            return false;
        }

        const seats = hall.sectors.toModelArray().map((sector) => {
            return sector.rows.toModelArray().map((row) => {
                return row.seats.toRefArray().length;
            });
        }).flat(2);

        return sum(seats) >= SEATS_NUMBER_REQUIRED_FOR_OPTIMIZATION;
    },
);

export default selectHallNeedToOptimize;
